import {
  TOGGLE_ITEM_MODAL,
  CHANGE_ITEM_MODAL_TAB,
  CLOSE_MAIN_MODAL,
  OPEN_MAIN_MODAL,
} from "./constants";

const initialState = {
  mainModalOpen: false,
  mainModelContent: "",
  mainModelTitle: "",
  mainModelCloseCB: null,
  mainModelBtnLabel: "",
  itemModalOpen: false,
  itemModalActiveTab: 0,
  activeTeamID: -1,
};

export function uiReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_MAIN_MODAL:
      return {
        ...state,
        mainModalOpen: true,
        mainModelContent: action.payload.content,
        mainModelTitle: action.payload.title,
        mainModelCloseCB: action.payload.closeCb,
        mainModelBtnLabel: action.payload.btnLabel,
        mainModelSecondaryCloseCB: action.payload.btnSecondaryCb,
        mainModelBtnSecondaryLabel: action.payload.btnSecondaryLabel,
      };
    case CLOSE_MAIN_MODAL:
      return {
        ...state,
        mainModalOpen: false,
        mainModelContent: "",
        mainModelTitle: "",
        mainModelCloseCB: null,
        mainModelBtnLabel: "",
      };
    case TOGGLE_ITEM_MODAL:
      return {
        ...state,
        itemModalOpen: !state.itemModalOpen,
        itemModalActiveTab: action.payload.itemModalActiveTab,
        activeTeamID: action.payload.activeTeamID,
      };
    case CHANGE_ITEM_MODAL_TAB:
      return {
        ...state,
        itemModalActiveTab: action.payload.itemModalActiveTab,
      };
    case "LOGOUT":
      return initialState;
    default:
      return state;
  }
}
